module.exports = __webpack_public_path__ + "static/metaWorkColor-6f58a5da9b8e4a14e1be8f161fa5e95c.gif";